/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rte_Link_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Paste or type a link…" |
*
* @param {Rte_Link_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const rte_link_placeholder = /** @type {((inputs?: Rte_Link_PlaceholderInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rte_Link_PlaceholderInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Plak of typ een link…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Collez ou tapez un lien…")
	return /** @type {LocalizedString} */ ("Paste or type a link…")
});